module.exports = __webpack_public_path__ + "assets/img/38709ea507a14aaedeffdd241a038460.png";